module.exports = __webpack_public_path__ + "img/symbol_4.73eca3ba.png";